import type { SegmentAnalytics } from "../../analytics"

// eslint-disable-next-line import/prefer-default-export
export const track: SegmentAnalytics[`track`] = (...args) => {
  try {
    if (
      typeof window !== `undefined` &&
      typeof window.analytics?.track === `function`
    ) {
      window.analytics.track(args[0], args[1])
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
  }
}
